import ASABI from '../abi/AnswerFirstV1.json'
import BaseByName from './BaseByName';
import { getWeb3 } from '../../helper/utils';
import { getContractsAddr } from '../config/ChainConfig.js';

export default class AnswerFirst extends BaseByName {
    constructor(provider) {
        super(provider, ASABI, 'AnswerFirstV1');
    }

    async _registerFee() {
        return await this.contract.methods._registerFee().call();
    }

    async _stakeFee() {
        return await this.contract.methods._stakeFee().call();
    }

    async _erc20() {
        return await this.contract.methods._erc20().call();
    }

    async _airDropId() {
        return await this.contract.methods._airDropId().call();
    }

    async _stakeDuration() {
        return await this.contract.methods._stakeDuration().call();
    }

    async getActivityInfo(id) {
        return await this.contract.methods.getActivityInfo(id).call();
    }

    async register(addr, type, tokenId = 0, referralCode = '') {
        // let value = new BigNumber(0);
        // return await this.provider.executeContract(this.contract, 'register', value, [type, tokenId]);
        console.log("tokenId:", tokenId)
        console.log("referralCode:", referralCode)
        return await this.contract.methods.register(type, tokenId, referralCode).send({from: addr});
    }
    
    async withdrawNFTs(addr) {
        return await this.contract.methods.withdrawNFTs().send({from: addr});
    }

    async getAllRegisterInfo(addr) {
        let web3 = getWeb3();

        let cid = process.env.VUE_APP_ENV == 'dev' ? 97 : 56;

        let tempContAddr = getContractsAddr(cid, 'AnswerFirstV1');
        web3.eth.defaultAccount = '0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe';

        let tempContract = new web3.eth.Contract(ASABI, tempContAddr);
        
        return await tempContract.methods.getAllRegisterInfo(addr).call();
    }
}